import axios from 'axios'
import config from '../config'
import qs from 'qs'
import {JsonHeaders} from '../constants'

export default {
    getCampaigns(currentPage, perPage, user_id) {
        return axios.get(config.publicPath + 'smtp_campaigns', {
            params: {
                _page: currentPage,
                itemsPerPage: perPage,
                order: {id: 'desc'},
                "user.id": user_id
            },
            paramsSerializer: qs.stringify
        });
    },
    getNotFinishedCampaigns(currentPage, perPage, search, user_id) {
        return axios.get(config.publicPath + 'campaigns/smtp', {
            params: {
                page: currentPage,
                perPage: perPage,
                orderBy: 'id',
                orderDirection: 'DESC',
                campaignName: search.campaignName,
                emailListName: search.emailListName,
                status: 'notFinished',
                userId: user_id
            },
            paramsSerializer: qs.stringify
        });
    },
    getFinishedCampaigns(currentPage, perPage, search, user_id) {
        return axios.get(config.publicPath + 'campaigns/smtp', {
            params: {
                page: currentPage,
                perPage: perPage,
                orderBy: 'id',
                orderDirection: 'DESC',
                campaignName: search.campaignName,
                emailListName: search.emailListName,
                status: 'finished',
                userId: user_id
            },
            paramsSerializer: qs.stringify
        });
    },
    createCampaign(formData) {
        return axios.post(config.publicPath + 'smtp_campaigns', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    getCampaign(id) {
        return axios.get(config.publicPath + 'smtp_campaigns/' + id, {
            headers: JsonHeaders
        });
    },
    updateCampaign(id, formData) {
        return axios.put(config.publicPath + 'smtp_campaigns/' + id, formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    startCampaign(campaign) {
        return axios.post(config.publicPath + 'campaign_start', campaign, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    stopCampaign(campaign) {
        return axios.post(config.publicPath + 'campaign_stop', campaign, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    pauseCampaign(campaign) {
        return axios.post(config.publicPath + 'campaign_pause', campaign, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getCampaignStatistics(id, type, provider = 0) {
        return axios.get(config.publicPath + 'smtp_campaign_statistics/' + id + '/' + type + '/' + provider, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    }
}
